import {
    Box,
    Text,
    Show,
} from '@chakra-ui/react';
import { TableSectionDesktopWithNav } from './TableSectionDesktopWithNav';
import { TableSectionMobileWithNav } from './TableSectionMobileWithNav';
import { StyledHeading } from '../TilesSection/styles';

export type DetailsInfo = {
    name: string;
    values: { [key: string]: boolean };
}

export type HeaderInfo = {
    title: string;
    price: string;
    crossedPrice?: string;
    priceTop?: string;
    priceColor?: string;
    priceInfo: string;
    linkName: string;
    href: string;
    type?: string;
}

export type SubscriptionInfo = {
    category: string;
    name: string;
    subtitle?: string;
    id?: string;
    tooltip?: string;
    isGray?: Boolean;
    values: any;
    details?: any;
};

export type TableSectionProps = {
    title: string;
    // valuesName: { [key: string]: string };
    subTitle?: string | JSX.Element;
    valuesName: { [key: string]: string };
    valuesNameMobile: { [key: string]: string };
    mainCategories: { [key: string]: string };
    tableSection: SubscriptionInfo[];
    tableColumns: Number;
    isOpenAll?: Boolean;
    isBlocked?: Boolean;
    headerValues: HeaderInfo[];
};

function TableSectionWithNav({
    title,
    subTitle,
    tableSection,
    mainCategories,
    valuesName,
    headerValues,
    tableColumns,
    isOpenAll,
    isBlocked,
    valuesNameMobile
}: TableSectionProps) {
    return (
        <Box>
            {/* <Heading textAlign={'center'} mb={6} as={'h2'} fontWeight={'600'}>
                {title}
            </Heading> */}
            <StyledHeading>{title}</StyledHeading>
            {typeof subTitle === 'object' ? (
                                subTitle
                            ) : (
                                <Text
                                    textAlign={"center"}
                                    fontSize={{md: 'md', lg: 'lg'}}
                                    color={'#171717'}
                                    mt={1}
                                >
                                    {subTitle}
                                </Text>
                            )}
            <Box mt={{base: '30px', lg: "45px"}} width={'100%'} id="subscriptions_table">
                <Show above="lg">
                    <TableSectionDesktopWithNav
                        tableSection={tableSection}
                        mainCategories={mainCategories}
                        valuesName={valuesName}
                        columns={tableColumns}
                        isOpenAll={isOpenAll}
                        isBlocked={isBlocked}
                        headerValues={headerValues}
                    />
                </Show>
                <Show below="lg">
                    <TableSectionMobileWithNav
                        tableSection={tableSection}
                        mainCategories={mainCategories}
                        valuesName={valuesName}
                        columns={tableColumns}
                        isOpenAll={isOpenAll}
                        isBlocked={isBlocked}
                        headerValues={headerValues}
                        valuesNameMobile={valuesNameMobile}
                    />
                </Show>
            </Box>
        </Box>
    );
}

export default TableSectionWithNav;
